export class ServicoListaRequest {
    pesquisa?: string;
}
